const RESERVED_WORD_PATTERN = /\b(test|user)\b/i;
const ALLOWED_NAME_PATTERN = /^[\p{L}\s'\-]+$/u;
// ponytail: iOS/Word Smart Punctuation; keep in sync with hris-external-orchestrator applicant-name.util.ts
const CURLY_APOSTROPHE_PATTERN = /[\u2018\u2019]/g;

export function normalizeApplicantName(name: string): string {
  return (name ?? "").replace(CURLY_APOSTROPHE_PATTERN, "'");
}

export function isAbusiveApplicantName(name: string): boolean {
  const trimmed = normalizeApplicantName(name).trim();
  if (!trimmed) return false;
  return (
    RESERVED_WORD_PATTERN.test(trimmed) ||
    !ALLOWED_NAME_PATTERN.test(trimmed)
  );
}

export function getApplicantNameAbuseMessage(
  firstName: string,
  lastName: string,
): string | null {
  if (
    isAbusiveApplicantName(firstName) ||
    isAbusiveApplicantName(lastName)
  ) {
    return "Please enter a valid first and last name using only letters, spaces, hyphens, and apostrophes.";
  }
  return null;
}
